const state = {
  user:{
    data: '',
    token: ''
  },
  movies: [],
  movieFilter: ''
}

export default state;